export default __webpack_public_path__ + "static/header-6e7474de48dedcc686d2647f83d2ca0f.png";